/* global Truework */
import { isProd } from 'shared/utils';
import { useRedux } from 'shared/hooks';
import { trueworkActions } from 'actions';
import useScript from './useScript';

const useTrueworkJS = () => {
  const scrpt = process.env.REACT_APP_TRUEWORK_SCRIPT;
  const [loaded, error] = useScript(scrpt);

  const { getTrueworkToken } = useRedux('trueworkReducer', trueworkActions);

  const twCreate = async ({ onOpen, onClose, onSuccess, onError }) => {
    if (loaded) {
      const { token } = await getTrueworkToken();

      const pk = process.env.REACT_APP_TRUEWORK_PUBLISHABLE_KEY;
      // @ts-ignore
      const creds = Truework.credentials.init({
        publishableKey: pk,
        sessionToken: token,
        // @ts-ignore
        env: isProd() ? Truework.credentials.Env.Production : Truework.credentials.Env.Sandbox,
      });

      if (creds) {
        creds.onOpen(onOpen);
        creds.onClose(onClose);
        creds.onSuccess(onSuccess);
        creds.onError((e) => {
          onError && onError(e);
          creds.close();
        });
        creds.open();
      }

      return {
        credentials: creds,
      };
    }
    return { credentials: null };
  };
  return { loaded, error, twCreate };
};

export default useTrueworkJS;
